import { useEffect } from "react";
import closeIcon from "/icons/close.svg";
import Button from "./Common/Button";
import { Modal } from "./Modal";

const ProfilePictureInformation = () => {
  return (
    <div className="flex max-md:flex-col items-center gap-9 bg-slate-50 my-4 p-4 rounded-xl">
      <div className="justify-center gap-2 grid">
        <a href="https://myaccount.microsoft.com/?ref=MeControl" target="_blank">
          <img className="mx-auto min-w-[104px]" src="/images/profile-placeholder.svg" alt="" />
        </a>{" "}
        <span className="w-max text-textFiller text-sm">UPDATE PHOTO</span>
      </div>
      <div>
        <h3 className="font-[450] text-textDefault text-2xl">Profile Picture</h3>
        <p className="text-textDefault text-lg">
          It is very important that you go over the{" "}
          <a className="text-motion600 underline" href="#">
            Care Access Headshot Guidelines
          </a>{" "}
          and adjust your profile picture if needed.
          <br />
          <br />
          To update your profile photo click on your photo above or{" "}
          <a
            className="text-motion600 underline"
            href="https://myaccount.microsoft.com/?ref=MeControl"
            target="_blank"
          >
            click here
          </a>{" "}
          to go directly to your profile page and change it there. Once updated, please sign out and
          back in again to make use of the new photo.
        </p>
      </div>
    </div>
  );
};

const AboutInput = ({
  title,
  description,
  image,
}: {
  title: string;
  description: string;
  image: string;
}) => {
  return (
    <div className="flex items-start gap-4">
      <img className="w-10 h-10" src={`/icons/${image}.svg`} alt="" />
      <div>
        <p className="font-medium text-textDefault text-lg">{title}</p>
        <p className="text-textDefault text-lg">{description}</p>
      </div>
    </div>
  );
};

export const Instructions = ({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
      <div className="grid bg-white w-full h-[calc(100svh-100px)]">
        <div className="flex justify-between items-start gap-2 pb-6 border-slate-200 border-b">
          <h5 className="font-PensumPro font-medium text-textDefault text-lg lg:text-2xl">
            Before using this tool, please read the following:
          </h5>
          <div onClick={() => setIsOpen(false)} className="min-w-6 cursor-pointer">
            <img className="w-6 h-6" src={closeIcon} alt="" />
          </div>
        </div>
        <div className="p-6 overflow-y-auto scroll">
          <ProfilePictureInformation />
          <h3 className="font-[450] text-textDefault text-2xl capitalize mt-8 mb-6">
            About your email signature
          </h3>
          <div className="gap-4 grid my-2">
            <AboutInput
              title="Headshot Photo"
              description='This tool will grab your Microsoft profile photo. To remove your photo, simply uncheck the "Use photo in signature" and your photo will be removed.'
              image="photo"
            />
            <AboutInput
              title="Full Name (Display Name)"
              description="You have the option to change the way your name shows up when someone receives an email from you. If there are no changes or corrections to your name, you can leave it as is."
              image="contact"
            />
            <AboutInput
              title="Role Title at Care Access"
              description="Please make sure you use the exact role title that has been approved by your supervisor."
              image="building"
            />
            <AboutInput
              title="Phone Number"
              description={`You may leave this blank or use your phone number as assigned by the IT team. When entering your phone number, please use the format "(area code) xxx-xxxx".`}
              image="phone"
            />
            <AboutInput
              title="Credentials"
              description={`This field is optional and not required. If you do have credentials that you wish to use, the company has a policy where one can only use credentials acquired within the US. Degrees or titles acquired outside of the states should not be included in this field.If you fill in this field, your Full Name (Display Name) will have the credentials appended automatically. (.e.g. "John Doe" would become "John Doe, PhD")`}
              image="graduation-cap"
            />
            <AboutInput
              title="Email Sign-off"
              description="This field is optional as well. It is included in this tool simply to make it easier for you to add your favorite sign-off (e.g. Best, Regards, etc.) right before your signature."
              image="envelope"
            />
          </div>
          <div className="bg-stateSuccessBackground p-4 border border-stateSuccess rounded-lg text-stateSuccessText mt-6">
            <div className="flex justify-items-center items-center gap-5 mx-auto max-w-[500px]">
              <img src="/icons/heart-handshake.svg" alt="" />
              <p>
                Thank you for your cooperation and please feel free to reach out to us at{" "}
                <a href="mailto:marketing@careaccess.com" className="text-motion600 underline">
                  marketing@careaccess.com
                </a>{" "}
                if you have any questions.
              </p>
            </div>
          </div>
        </div>

        <div className="flex justify-end bg-white pt-4 border-slate-300 border-t">
          <Button onClick={() => setIsOpen(false)}>
            Use The Tool <img src="/icons/arrow.svg" alt="" />
          </Button>
        </div>
      </div>
    </Modal>
  );
};
